import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { PathNavItem } from './constants';

type PathItemProps = {
  isActive: boolean;
  pathItem: PathNavItem;
  setActive: (value: string) => void;
};

const PathItem: React.FC<PathItemProps> = ({
  isActive,
  pathItem,
  setActive,
}) => {
  return (
    <Box
      sx={{
        cursor: 'pointer',
        border: isActive ? '1px solid #000' : '',
      }}
      p={1}
      my={1}
      borderRadius='24px'
      minWidth={{
        sm: '150px',
      }}
      onClick={() => {
        setActive(pathItem.id);
        window.location.href = `#${pathItem.id}`;
      }}
    >
      <Typography
        fontSize={{
          sm: '14px',
          md: '16px',
        }}
        lineHeight='24px'
      >
        {pathItem.title}
      </Typography>
    </Box>
  );
};

export default PathItem;
